// Tymczasowe identyfikatory nowych punktów i załączników porządku obrad.
// Serwer i tak nadaje własne Id i odsyła mapowanie w SaveAgendaResponse.NewItems —
// te GUID-y żyją tylko do momentu pierwszego zapisu.

export const newId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback dla kontekstów bez crypto.randomUUID (np. http na starszej przeglądarce).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
